// removed by extract-text-webpack-plugin
module.exports = {"first-paragraph":"_3G4Q0","link":"_1qzFW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FaqQuestion.less
// module id = ./src/components/Home/FaqQuestion.less
// module chunks = 2